@if (label) {
  <label
    class="ui-label ui-label--{{ labelSize }}"
    [ngClass]="{ 'ui-label--required': isRequired }"
    [attr.for]="inputId"
  >
    {{ label }}
  </label>
}

<div class="ui-input__editor">
  <div
    class="ui-input__switch"
    [ngClass]="{
      'ui-input__switch--active': isChecked,
      'ui-input__switch--disabled': isDisabled,
      'ui-input__switch--animated': isInteracted(),
      'ui-input__switch--dragging': knobTransform() !== null,
    }"
    (click)="onToggle($event)"
    (pointerdown)="onDragStart($event)"
    (pointermove)="onDragMove($event)"
    (pointerup)="onDragEnd($event)"
    (pointercancel)="onDragCancel($event)"
    (lostpointercapture)="onDragCancel($event)"
  >
    <input
      #input
      class="ui-input__switch-input ui-input__switch-toggle"
      type="checkbox"
      [attr.aria-label]="ariaLabel()"
      [checked]="isChecked"
      [value]="isChecked ? 'on' : 'off'"
      [style.transform]="knobTransform()"
    />
  </div>

  @if (legend) {
    <label
      (click)="onToggle($event)"
      [attr.for]="inputId"
      class="ui-input__checkbox-legend"
      [ngClass]="{ 'ui-input__checkbox-legend--read-only': isDisabled }"
    >
      {{ legend }}
    </label>
  }
</div>

@if (shouldDisplayErrors) {
  <div class="ui-input__error-wrapper">
    <p class="ui-input__error">{{ getErrorMessage(errorEntries[0]) }}</p>
  </div>
}

@if (helper) {
  <p class="ui-helper">
    {{ helper }}
  </p>
}

<ng-content />
